import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import axios from "axios";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import styled from "styled-components";
import AttachmentsList from "../../../Componentes/Utils/AttachmentsList";

const ContainerAnexo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`

const TituloAnexo = styled.p`
    margin: 0 auto 0 auto;
    color: #000;
    font-weight: bold;
`

const PreencherItem = ({ id, fetchSuccess }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);
    const [editingItem, setEditingItem] = useState(false);
    const [finishedItem, setFinishedItem] = useState(false);

    const [formValues, setFormValues] = useState({
        item: '',
        conforme: '',
        apontamento: '',
        acaoCorretiva: '',
        dataPrazo: '',
        dataRealizada: ''
    })
    const [beforeAttachments, setBeforeAttachments] = useState([]);
    const [afterAttachments, setAfterAttachments] = useState([]);

    const [beforeAttachmentsList, setBeforeAttachmentsList] = useState([]);
    const [afterAttachmentsList, setAfterAttachmentsList] = useState([]);

    useEffect(() => {

        const fetchData = async () => {

            setLoading(true);

            try {

                const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetInfoItem/index.php?id=${id}`);
                console.log(data);

                setEditingItem(!!data?.preenchido_at);
                setFinishedItem(!!data?.data_realizada);

                setFormValues((prev) => ({
                    ...prev,
                    item: data.item,
                    conforme: data?.conforme || '',
                    apontamento: data?.apontamento || '',
                    acaoCorretiva: data?.acao_corretiva || '',
                    dataPrazo: data?.data_prazo || '',
                    dataRealizada: data?.data_realizada || ''
                }))

                if( data.anexos.length > 0 ){

                    const anexosAntes = data.anexos.filter(( obj ) => obj.type === 'before');
                    const anexosDepois = data.anexos.filter(( obj ) => obj.type === 'after');

                    setBeforeAttachmentsList( anexosAntes );
                    setAfterAttachmentsList( anexosDepois );

                }

            } catch (e) {

                console.error(e);

            } finally {

                setLoading(false);

            }

        }

        if (id) {
            fetchData();
        }

    }, [id]);

    const handleChange = (e, name) => {

        const { value } = e.target;

        setFormValues((prev) => ({
            ...prev,
            [name]: value
        }))

    }

    useEffect(() => {
        setFormValues((prev) => {
            let updated = { ...prev };

            if (!['OM', 'NC'].includes(prev.conforme)) {
                updated.apontamento = '';
            }

            if (prev.conforme !== 'NC') {
                updated.acaoCorretiva = '';
                updated.dataPrazo = '';
                updated.dataRealizada = '';
                setAfterAttachments([]);
            }

            return updated;
        });
    }, [formValues.conforme]);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const formData = new FormData();

            formData.append('id', id);
            formData.append('conformidade', formValues.conforme)
            if (formValues.conforme === 'OM') {
                formData.append('apontamento', formValues.apontamento)
            }
            if (formValues.conforme === 'NC') {
                formData.append('apontamento', formValues.apontamento)
                formData.append('acao_corretiva', formValues.acaoCorretiva)
                formData.append('data_prazo', formValues.dataPrazo)
                formData.append('data_realizada', formValues.dataRealizada)
            }

            if (beforeAttachments.length > 0) {
                beforeAttachments.forEach((f, index) => {
                    formData.append(`anexos_before[${index}]`, f.file);
                })
            }

            if (afterAttachments.length > 0) {
                afterAttachments.forEach((f, index) => {
                    formData.append(`anexos_after[${index}]`, f.file);
                })
            }

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/UpdateConformidade/', formData, {
                withCredentials: true
            })

            fetchSuccess?.();
            closeModal();

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="ITEM"
                            readOnly
                            type="text"
                            valor={formValues.item}
                        />
                        <FormComp
                            title="CONFORMIDADE"
                            type={editingItem ? "text" : "select"}
                            options={["C", "N/A", "OM", "NC"]}
                            valor={formValues.conforme}
                            changeFunc={(e) => handleChange(e, 'conforme')}
                            required
                            readOnly={editingItem}
                        />
                        {['OM', 'NC'].includes(formValues.conforme) && (
                            <FormComp
                                title="APONTAMENTO"
                                type="textarea"
                                valor={formValues.apontamento}
                                changeFunc={(e) => handleChange(e, 'apontamento')}
                                required
                                readOnly={editingItem}
                            />
                        )}
                        {!editingItem && (
                            <ContainerAnexo>
                                <TituloAnexo>FOTO ANTES</TituloAnexo>
                                <MultiFileUploader
                                    files={beforeAttachments}
                                    setFiles={setBeforeAttachments}
                                />
                            </ContainerAnexo>
                        )}
                        {(formValues.conforme === "NC") && (
                            <>
                                <FormComp
                                    title="AÇÃO CORRETIVA"
                                    type="textarea"
                                    valor={formValues.acaoCorretiva}
                                    changeFunc={(e) => handleChange(e, 'acaoCorretiva')}
                                    required
                                    readOnly={finishedItem}
                                />
                                {!finishedItem && (
                                    <ContainerAnexo>
                                        <TituloAnexo>FOTO DEPOIS</TituloAnexo>
                                        <MultiFileUploader
                                            files={afterAttachments}
                                            setFiles={setAfterAttachments}
                                        />
                                    </ContainerAnexo>
                                )}
                                <FormComp
                                    title="DATA PRAZO"
                                    type="date"
                                    valor={formValues.dataPrazo}
                                    changeFunc={(e) => handleChange(e, 'dataPrazo')}
                                    readOnly={editingItem}
                                />
                                <FormComp
                                    title="DATA REALIZADA"
                                    type="date"
                                    valor={formValues.dataRealizada}
                                    changeFunc={(e) => handleChange(e, 'dataRealizada')}
                                    readOnly={finishedItem}
                                />
                            </>
                        )}
                        {beforeAttachmentsList.length > 0 && (
                            <AttachmentsList
                                titulo="ANEXOS ANTES"
                                files={ beforeAttachmentsList }
                            />
                        )}
                        {afterAttachmentsList.length > 0 && (
                            <AttachmentsList
                                titulo="ANEXOS DEPOIS"
                                files={ afterAttachmentsList }
                            />
                        )}
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
                {loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </Overlay>
        </>
    )
}

export default PreencherItem;